import {combineReducers} from 'redux'
import * as at from './actionTypes'
import {routerReducer} from 'react-router-redux'
import {buildDTNData, buildCPIPData} from './helpers/feedParser'
import {API_JSON_KEY} from './constants'
import {defaultsIndexFor} from './helpers/defaultNumbers'
import {consoleLogGroup} from './helpers/consolelog'
import _ from 'lodash'

const app = (
  state = {
    isFetchingFeedData: false,
    isLoggedIn: false,
  },
  action,
) => {
  switch (action.type) {
    case at.FETCHING_FEED_DATA: {
      return _.assign({}, state, {
        isFetchingFeedData: action.payload.isLoading,
      })
    }
    case at.UPDATE_LOGIN: {
      return _.assign({}, state, {
        isLoggedIn: action.payload.isLoggedIn,
      })
    }
    default: {
      return state
    }
  }
}

const data = (
  state = {
    dtn: null,
    cpip: null,
    basis: [],
    data: {},
    settlementindices: {},
  },
  action,
) => {
  switch (action.type) {
    case at.UPDATE_DATA: {
      return _.assign({}, state, {
        dtn: buildDTNData(action.payload.data),
        cpip: buildCPIPData(action.payload.data),
        basis: action.payload.data[API_JSON_KEY.basis],
        data: action.payload.data,
        settlementindices: action.payload.data[API_JSON_KEY.settlementIndices],
      })
    }
    default:
      return state
  }
}

export const DEFAULT_NUMBERS_INITIAL_STATE = {
  global: {
    barleyCost: 250.0,
    barleyCostUserSet: false,
    supplementCost: 380.0,
    silageCost: null,
  },
  finishing: {
    heifer: [
      {
        inWeightStart: 0,
        outWeight: 1175,
        avgDailyGain: 2.6,
        barley: 17.7,
        silage: 3.9,
        supplement: 0.5,
        truckingInPerHead: 9.5,
        marketingPerHead: 5,
        yardagePerDay: 0.5,
        vetAndMedPerHead: 30,
        deathLossPerHead: 17,
        beddingPerHead: 11.25,
        interestPerHead: 20,
      },
      {
        inWeightStart: 500,
        outWeight: 1225,
        avgDailyGain: 2.75,
        barley: 18.9,
        silage: 5.6,
        supplement: 0.6,
        truckingInPerHead: 11.5,
        marketingPerHead: 5,
        yardagePerDay: 0.5,
        vetAndMedPerHead: 30,
        deathLossPerHead: 17,
        beddingPerHead: 11.25,
        interestPerHead: 20,
      },
      {
        inWeightStart: 600,
        outWeight: 1250,
        avgDailyGain: 2.8,
        barley: 19.4,
        silage: 6.3,
        supplement: 0.7,
        truckingInPerHead: 13,
        marketingPerHead: 5,
        yardagePerDay: 0.5,
        vetAndMedPerHead: 25,
        deathLossPerHead: 17,
        beddingPerHead: 12.5,
        interestPerHead: 20,
      },
      {
        inWeightStart: 700,
        outWeight: 1300,
        avgDailyGain: 3.0,
        barley: 21.2,
        silage: 6,
        supplement: 0.7,
        truckingInPerHead: 15,
        marketingPerHead: 5,
        yardagePerDay: 0.5,
        vetAndMedPerHead: 25,
        deathLossPerHead: 15,
        beddingPerHead: 10,
        interestPerHead: 20,
      },
      {
        inWeightStart: 800,
        outWeight: 1325,
        avgDailyGain: 3.15,
        barley: 22.4,
        silage: 6,
        supplement: 0.7,
        truckingInPerHead: 17,
        marketingPerHead: 5,
        yardagePerDay: 0.5,
        vetAndMedPerHead: 20,
        deathLossPerHead: 12,
        beddingPerHead: 8.5,
        interestPerHead: 20,
      },
      {
        inWeightStart: 900,
        outWeight: 1340,
        avgDailyGain: 3.2,
        barley: 22.2,
        silage: 7.4,
        supplement: 0.8,
        truckingInPerHead: 17.75,
        marketingPerHead: 5,
        yardagePerDay: 0.5,
        vetAndMedPerHead: 20,
        deathLossPerHead: 12,
        beddingPerHead: 7.25,
        interestPerHead: 20,
      },
    ],
    steer: [
      {
        inWeightStart: 0,
        outWeight: 1260,
        avgDailyGain: 3.1,
        barley: 19.8,
        silage: 3.6,
        supplement: 0.5,
        truckingInPerHead: 9.5,
        marketingPerHead: 5,
        yardagePerDay: 0.5,
        vetAndMedPerHead: 30,
        deathLossPerHead: 20,
        beddingPerHead: 11.25,
        interestPerHead: 23,
      },
      {
        inWeightStart: 500,
        outWeight: 1325,
        avgDailyGain: 3.25,
        barley: 20.8,
        silage: 6.3,
        supplement: 0.7,
        truckingInPerHead: 11.5,
        marketingPerHead: 5,
        yardagePerDay: 0.5,
        vetAndMedPerHead: 30,
        deathLossPerHead: 18,
        beddingPerHead: 11.5,
        interestPerHead: 23,
      },
      {
        inWeightStart: 600,
        outWeight: 1350,
        avgDailyGain: 3.3,
        barley: 21,
        silage: 7,
        supplement: 0.7,
        truckingInPerHead: 13,
        marketingPerHead: 5,
        yardagePerDay: 0.5,
        vetAndMedPerHead: 25,
        deathLossPerHead: 18,
        beddingPerHead: 13.75,
        interestPerHead: 23,
      },
      {
        inWeightStart: 700,
        outWeight: 1375,
        avgDailyGain: 3.5,
        barley: 22.5,
        silage: 6.5,
        supplement: 0.7,
        truckingInPerHead: 15,
        marketingPerHead: 5,
        yardagePerDay: 0.5,
        vetAndMedPerHead: 25,
        deathLossPerHead: 15,
        beddingPerHead: 11,
        interestPerHead: 23,
      },
      {
        inWeightStart: 800,
        outWeight: 1400,
        avgDailyGain: 3.6,
        barley: 23.5,
        silage: 6.7,
        supplement: 0.8,
        truckingInPerHead: 17,
        marketingPerHead: 5,
        yardagePerDay: 0.5,
        vetAndMedPerHead: 20,
        deathLossPerHead: 12,
        beddingPerHead: 8.5,
        interestPerHead: 20,
      },
      {
        inWeightStart: 900,
        outWeight: 1415,
        avgDailyGain: 3.65,
        barley: 22.8,
        silage: 8,
        supplement: 0.8,
        truckingInPerHead: 17.75,
        marketingPerHead: 5,
        yardagePerDay: 0.5,
        vetAndMedPerHead: 20,
        deathLossPerHead: 10,
        beddingPerHead: 7.5,
        interestPerHead: 20,
      },
    ],
  },
  projection: {
    heifer: [
      {
        inWeightStart: 0,
        finishedDate: null,
      },
      {
        inWeightStart: 500,
        finishedDate: null,
      },
      {
        inWeightStart: 600,
        finishedDate: null,
      },
      {
        inWeightStart: 700,
        finishedDate: null,
      },
      {
        inWeightStart: 800,
        finishedDate: null,
      },
      {
        inWeightStart: 900,
        finishedDate: null,
      },
    ],
    steer: [
      {
        inWeightStart: 0,
        finishedDate: null,
      },
      {
        inWeightStart: 500,
        finishedDate: null,
      },
      {
        inWeightStart: 600,
        finishedDate: null,
      },
      {
        inWeightStart: 700,
        finishedDate: null,
      },
      {
        inWeightStart: 800,
        finishedDate: null,
      },
      {
        inWeightStart: 900,
        finishedDate: null,
      },
    ],
  },
}

export const updateDefaultNumbers = (
  state = DEFAULT_NUMBERS_INITIAL_STATE,
  action,
) => {
  const createGlobalDefaults = (state, key, value) => {
    return {
      global: {
        ...state.global,
        [key]: value,
        barleyCostUserSet:
          state.global.barleyCostUserSet || key === 'barleyCost',
      },
    }
  }
  switch (action.type) {
    case at.UPDATE_BARLEY_COST: {
      if (state.global.barleyCostUserSet) {
        return state
      }

      return _.assign({}, state, {
        global: {
          ...state.global,
          [action.payload.data.key]: action.payload.data.value,
        },
      })
    }
    case at.BACKGROUNDER_UPDATE_DEFAULT_NUMBER: {
      return _.assign(
        {},
        state,
        createGlobalDefaults(
          state,
          action.payload.data.key,
          action.payload.data.value,
        ),
      )
    }
    case at.PROJECTION_UPDATE_DEFAULT_NUMBER: {
      const {key, value, type, inWeight} = action.payload.data
      consoleLogGroup('Values', {key, value, type, inWeight})
      if (key === 'finishedDate') {
        var pIndex = defaultsIndexFor(state, 'projection', type, inWeight)
        if (pIndex !== null && key in state['projection'][type][pIndex]) {
          var pNextState = _.assign({}, state)
          var pAlterObject = _.assign({}, state['projection'][type][pIndex])
          pAlterObject[key] = value
          pNextState['projection'][type][pIndex] = pAlterObject
          return pNextState
        } else {
          return state
        }
      }
    }
    // Purposely fallthrough as the next key would be the finishing weight that we'd like to update
    /* eslint-disable no-fallthrough */
    case at.FINISHING_UPDATE_DEFAULT_NUMBER: {
      const {key, value, type, inWeight} = action.payload.data
      var fIndex = defaultsIndexFor(state, 'finishing', type, inWeight)
      if (fIndex === null) {
        return _.assign({}, state, createGlobalDefaults(state, key, value))
      } else {
        var fNextState = _.assign({}, state)
        var fAlterObject = _.assign({}, state['finishing'][type][fIndex])
        fAlterObject[key] = value
        fNextState['finishing'][type][fIndex] = fAlterObject
        return fNextState
      }
    }
    /* eslint-enable no-fallthrough */
    case at.USER_DATA_UPDATE:
    case at.USER_LOGIN: {
      return action.payload.defaultNumbers
    }
    case at.REPLACE_ALL_DEFAULTS: {
      return action.payload.data
    }
    case at.USER_LOGOUT:
    case at.USER_CLEAR_DATA:
    case at.USER_RESET_DEFAULTS: {
      return DEFAULT_NUMBERS_INITIAL_STATE
    }
    default:
      return state
  }
}

const defaultNumbers = updateDefaultNumbers

const INITIAL_USER_DATA_STATE = {
  userId: null,
  backgrounders: {},
  finishings: {},
  projections: {},
  didAcceptToS: false,
}

const userData = (state = INITIAL_USER_DATA_STATE, action) => {
  const actionSplit = action.type.split('_')
  const userDataType = actionSplit[0].toLowerCase()
  if (!_.includes(_.keys(state), userDataType) && userDataType !== 'user') {
    return state
  }

  const actionType = actionSplit[1].toLowerCase()
  if (actionType === 'delete') {
    const {id} = action.payload
    return stateDelete(state, userDataType, id)
  } else if (actionType === 'save' || actionType === 'update') {
    const {data} = action.payload
    return stateSave(state, userDataType, data.id, data)
  }

  switch (action.type) {
    case at.USER_DATA_UPDATE:
    case at.USER_LOGIN: {
      const userId = action.payload.user_id
      const didAcceptToS = action.payload.did_accept_tos

      const arrayToKeyObject = (arr, key) => {
        var results = {}
        arr.forEach((element) => {
          results[element[key]] = element
        })
        return results
      }

      var backgrounders = arrayToKeyObject(action.payload.backgrounders, 'id')
      var finishings = arrayToKeyObject(action.payload.finishing, 'id')
      var projections = arrayToKeyObject(action.payload.projections, 'id')

      return {
        userId,
        didAcceptToS,
        backgrounders,
        finishings,
        projections,
      }
    }
    case at.USER_ACCEPTED_TOS: {
      return _.assign({}, state, {didAcceptToS: action.payload})
    }
    case at.USER_CLEAR_DATA:
    case at.USER_LOGOUT: {
      return {
        ...INITIAL_USER_DATA_STATE,
        didAcceptToS: state.didAcceptToS,
      }
    }
    default: {
      return state
    }
  }
}

export default combineReducers({
  app,
  data,
  userData,
  defaultNumbers,
  router: routerReducer,
})

const stateSave = (currentState, type, id, data) => {
  return _.assign({}, currentState, {
    [type]: {
      ...currentState[type],
      [id]: data,
    },
  })
}

const stateDelete = (currentState, type, id) => {
  var oldState = _.assign({}, currentState[type])
  delete oldState[id]
  return _.assign({}, currentState, {
    [type]: {
      ...oldState,
    },
  })
}



// WEBPACK FOOTER //
// ./src/reducers.js